import React from 'react'
import { makeStyles, Dialog, Slide, DialogContent } from '@material-ui/core'
import { ModalTitleIconed } from 'asterX-UI/Modals'

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    position: 'fixed',
    bottom: 0,
    margin: 0,
    borderRadius: '8px 8px 0 0',
    paddingBottom: 20
  }
}))

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />
})

const BottomDialog = ({ open, onClose, children, title = '', subtitle = '', iconComponent = null }) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: classes.dialogPaper
      }}
      TransitionComponent={Transition}
    >
      <ModalTitleIconed onClose={onClose} iconComponent={iconComponent} subtitle={subtitle}>
        {title}
      </ModalTitleIconed>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  )
}

export default BottomDialog
